@if (isChartModeHandelssortimentsgruppEnabled() && isProduktionsmalPlanTopModeEnabled()) {
  <rask-button
    color="tertiary"
    (click)="loadHandelssortimentsgrupper()">
    Tillbaka
  </rask-button>
}

<rask-chart
  (chartClick)="onChartClick($event)"
  [ngStyle]="{height: chartHeight}"
  [chartObject]="chartConfiguration">
</rask-chart>

@if (negativeGoals?.length > 0) {
  <div class="alert-negative-goals col-12">
    <rask-icon icon="fal fa-exclamation-triangle">Varning</rask-icon>
    {{getCommaListedNegativeGoals()}} har obalans mellan kundorder och lager, bör ej produceras.
  </div>
}
